module.exports = __webpack_public_path__ + "img/noImg.b0012cc4.jpg";